module.exports = __webpack_public_path__ + "images/category_lp/pc/lppc-Hikaku_KaitoriCase4_56152a12e2074263f0e2e34625d84053.png";